import { useEffect, useState } from 'react';
import {
  ScreenScrapeForm,
  ScreenScrapeFormFooter,
} from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeForm';
import { Controller, useForm } from 'react-hook-form';
import styled from 'styled-components';
import { ScreenScrapeButton } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeButton';
import { Checkbox } from 'src/pages/MainPage/components/ConsentForm/Checkbox';
import { AccountInfo } from 'src/common/models/message';
import { useSSContext } from 'src/pages/AspspSelectPage/ScreenScrape/useSSContext';
import { ScreenScrapeStepTitle } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeStepTitle';
import { ScreenScrapeLoader } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeLoader';
import { filterChecked } from 'src/pages/AspspSelectPage/ScreenScrape/common/filterChecked';

const ListItem = styled.div`
  margin: 1rem 0;

  label {
    width: 100%;
    display: flex;

    > :not(:first-child) {
      width: 100%;
    }
  }
`;

const ListItemText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &:last-child {
    text-align: right;
  }
`;

const Labels = styled.span`
  display: grid;
  grid-template-columns: 3fr 1.5fr;
`;

const ListContainer = styled.div`
  max-height: 12rem;
  overflow-y: auto;
`;

export type ChooseAccountFormModel = Record<string, boolean | undefined>;

export const ScreenScrapeChooseAccount = () => {
  const ctx = useSSContext();
  const [valid, setValid] = useState(false);

  const { control, handleSubmit, watch } = useForm<ChooseAccountFormModel>();

  const accounts = ctx.lastJsonMessage?.object as AccountInfo[];

  useEffect(() => {
    const subscription = watch((value) => {
      setValid(filterChecked(value).length > 0);
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const onSubmit = (data: ChooseAccountFormModel) => {
    if (valid) {
      const body = filterChecked(data).flatMap((entry) => entry[0]);

      ctx.submitStep(null, body);
    }
  };

  return ctx.isLoading ? (
    <ScreenScrapeLoader />
  ) : (
    <>
      <ScreenScrapeStepTitle>
        {ctx.lastJsonMessage?.value}
      </ScreenScrapeStepTitle>
      <ScreenScrapeForm onSubmit={handleSubmit(onSubmit)}>
        <ListContainer>
          {accounts &&
            accounts.map((account) => (
              <Controller
                key={account.accountNumber}
                name={`${account.accountNumber}` as const}
                control={control}
                render={({ field }) => (
                  <ListItem>
                    <Checkbox
                      {...field}
                      label={
                        <Labels>
                          <ListItemText>{account.accountName}</ListItemText>
                          <ListItemText>
                            {account.accountShortNumber}
                          </ListItemText>
                        </Labels>
                      }
                    />
                  </ListItem>
                )}
              />
            ))}
        </ListContainer>
        <ScreenScrapeFormFooter>
          <ScreenScrapeButton type="submit" disabled={!valid}>
            Potwierdź
          </ScreenScrapeButton>
        </ScreenScrapeFormFooter>
      </ScreenScrapeForm>
    </>
  );
};
